import { IconWrapper, ISvgIconProps } from "@icon-park/svg/lib/runtime";

const createThermometer = (temp: number) => {
  const y = Math.max(0, Math.min(((100 - temp) / 100) * 18 + 12, 30));
  return IconWrapper(
    "Thermometer",
    (props: ISvgIconProps) =>
      '<?xml version="1.0" encoding="UTF-8"?>' +
      `<svg width="${props.size}" height="${props.size}" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">` +
      `<path d="M18 25.9993V10C18 6.68629 20.6863 4 24 4C27.3137 4 30 6.68629 30 10V25.9993C32.4289 27.8237 34 30.7284 34 34C34 39.5228 29.5228 44 24 44C18.4772 44 14 39.5228 14 34C14 30.7284 15.5711 27.8237 18 25.9993Z" 
    fill="${props.colors[1]}" stroke="${props.colors[0]}" stroke-width="${props.strokeWidth}" stroke-linejoin="${props.strokeLinejoin}"/>` +
      `<path d="M24 ${y}V30" stroke="${props.colors[2]}" stroke-width="${props.strokeWidth}" stroke-linecap="${props.strokeLinecap}" stroke-linejoin="${props.strokeLinejoin}"/>` +
      `<path d="M24 38C26.2091 38 28 36.2091 28 34C28 31.7909 26.2091 30 24 30C21.7909 30 20 31.7909 20 34C20 36.2091 21.7909 38 24 38Z" fill="${props.colors[3]}"  stroke="${props.colors[2]}" stroke-width="${props.strokeWidth}" stroke-linejoin="${props.strokeLinejoin}"/>` +
      "</svg>",
  );
};

export const ThermometerCold = createThermometer(0);
export const ThermometerWarm = createThermometer(50);
export const ThermometerHot = createThermometer(100);
